import { ActionType } from "../../../base/types";
import { FC } from "react";
import { IActionAttributes } from "../../../base/models";
import { MUIIcon } from "../../../widgets";
import { Registry } from "../../../base/register";
import clsx from "clsx";

export const ActionGroupComponent: FC<IActionAttributes> = ({
    action, className, children
}) => {
    return (
        <div className={clsx(className, "px-5 py-2")}>
            <div className="d-flex gap-1">
                {action.icon && <MUIIcon iconName={action.icon} />}
                <span>{action.name}</span>
            </div>
            {children}
        </div>)
}

Registry.addAction({
    id: "7a8bad5b-23d7-405f-bc8b-0a26c853aaa1",
    name: "Action Group",
    type: ActionType.ActionGroup,
    properties: [],
    component: ActionGroupComponent
})
